<script setup>
  import Accordion from 'primevue/accordion';
  import AccordionContent from 'primevue/accordioncontent';
  import AccordionHeader from 'primevue/accordionheader';
  import AccordionPanel from 'primevue/accordionpanel';

  import HomeSectionHeading from '@/components/home/HomeSectionHeading.vue';

  import { HOME_FAQ } from '@/constants/home';

  import chevronIcon from '@/assets/images/home/faq-chevron.svg';
  import faqIcon from '@/assets/images/home/icon-faq.svg';

  const INK = '#0f0202';
  const accordionTokens = {
    panel: { borderWidth: '0 0 3px 0', borderColor: INK },
    header: {
      padding: '0',
      borderWidth: '0',
      first: { borderWidth: '0' },
      color: INK,
      hoverColor: INK,
      activeColor: INK,
      activeHoverColor: INK,
      focusRing: { width: '2px', style: 'solid', color: '#2450ed', offset: '4px', shadow: 'none' },
    },
    content: { padding: '0', borderWidth: '0', background: 'transparent', color: INK },
    colorScheme: {
      light: {
        header: {
          background: 'transparent',
          hoverBackground: 'transparent',
          activeBackground: 'transparent',
          activeHoverBackground: 'transparent',
        },
      },
    },
  };
</script>

<template>
  <section
    id="faq"
    class="w-full scroll-mt-18 pt-22 pb-28 md:scroll-mt-21 md:pt-24 md:pb-40 lg:scroll-mt-25 xl:pt-23 xl:pb-50"
  >
    <div class="mx-auto flex w-full max-w-299 flex-col items-center px-7 md:px-8 xl:px-0">
      <img :src="faqIcon" alt="" class="size-10 md:size-12 lg:size-13" />

      <HomeSectionHeading
        v-reveal
        large
        class="mt-15 lg:mt-13"
        :eyebrow="HOME_FAQ.eyebrow"
        :title="HOME_FAQ.title"
      />

      <Accordion
        v-reveal="100"
        value="0"
        :dt="accordionTokens"
        class="border-ink mt-8 w-full border-t-3 lg:mt-15"
      >
        <AccordionPanel
          v-for="(item, index) in HOME_FAQ.items"
          :key="item.question"
          :value="String(index)"
        >
          <h3>
            <!-- ! because PrimeVue resets the header button with an unlayered `all: unset` -->
            <AccordionHeader class="w-full! gap-3! md:gap-6!">
              <template #default="{ active }">
                <span
                  :class="[
                    'text-ink pt-5.5 text-left text-[24px] leading-[1.22] font-bold transition-[padding] duration-200 md:text-[26px] lg:pt-10 lg:pl-1 lg:text-[29px]/9.5',
                    active ? 'pb-6 lg:pb-7' : 'pb-5.5 lg:pb-10',
                  ]"
                >
                  {{ item.question }}
                </span>
              </template>
              <template #toggleicon="{ active }">
                <img
                  :src="chevronIcon"
                  alt=""
                  :class="[
                    'w-4 shrink-0 transition-transform duration-200 md:w-6 lg:mr-5 lg:w-7.5',
                    !active && 'rotate-180',
                  ]"
                />
              </template>
            </AccordionHeader>
          </h3>

          <AccordionContent>
            <p
              class="text-ink pb-6 text-[15px]/6 font-medium lg:max-w-280 lg:pb-17 lg:text-[18px]/6.5"
            >
              {{ item.answer }}
            </p>
          </AccordionContent>
        </AccordionPanel>
      </Accordion>
    </div>
  </section>
</template>
